import { TowTruckIcon } from '@rsos/assets/icons';
import { ActionBarItem } from '../ActionBarItem';
import useRoadsideAssistanceHelpers from './useRoadsideAssistanceHelpers';

const RoadsideAssistanceActionBarItem = () => {
  const tooltipText = 'Request Lockout, Flat Tire, & Roadside Help';

  const {
    handleRoadsideAssistanceClick,
    isRoadsideAssistanceEnabled,
    isRoadsideAssistanceCardOpened,
  } = useRoadsideAssistanceHelpers();

  if (!isRoadsideAssistanceEnabled) {
    return null;
  }

  return (
    <ActionBarItem
      iconWidth="18px"
      shouldRender={isRoadsideAssistanceEnabled}
      onClick={handleRoadsideAssistanceClick}
      tooltipText={tooltipText}
      isActive={isRoadsideAssistanceCardOpened}
      iconDataName="roadside-assistance-action-bar-item-icon"
    >
      <TowTruckIcon />
    </ActionBarItem>
  );
};

export default RoadsideAssistanceActionBarItem;
